/* src/app/app.component.css */
.particles {
  z-index: -100;
  height: 200px;
  display: inline;
}
.websiteContent {
  background-color: white;
}
/*# sourceMappingURL=app.component.css.map */
